import Backbone from 'backbone'
import WizardInfo from './reports-wizard-info'
import DefaultWizardLayout from './reports-wizard-layout'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import FormView from 'scoreboard/components/form-view'
import _ from 'lodash'
import unwrapModel from 'scoreboard/components/unwrap-model'

var ReportWizard = Backbone.View.extend({

	tagName: 'form',

	className: 'reports wizard',

	initialize: function(options = {}) {
		this.options = options
		this.model = this.model || new WizardInfo(arguments)
		//The default wizard layout used 3 separate views to compose the wizard
		//a header, body and footer view.  Some reports paths however may want
		//to use a single view for their presentation, and may do so by defining
		//a layout view within their path
		this.content = new DefaultWizardLayout({model: this.model})

		let allowCleanSubmission = false
		const path = this.model.get('path')
		if (path) {
			// #42228 if all steps pass validation, then we have all the information
			// we need to continue
			const attrs = unwrapModel(path.model)
			// Check for first instance of an invalid step, rather than checking
			// that all steps are valid
			allowCleanSubmission = !_.some(path.steps, s => !s.validate(attrs))
		}
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission
		})

		// Ensure the dialog resizes when we're switching dialog views.
		// process.nextTick ensures we wait till the new view is in place to resize
		this.listenTo(this.model, 'transition', function() {
			process.nextTick(function() {
				this.trigger('resize')
			}.bind(this))
		}.bind(this))

		this.listenToOnce(this.model, 'done', function(report) {
			if (_.isFunction(this.options.onDone)) {
				this.options.onDone(report, this)
			} else {
				this.trigger('done', report)
			}
		}.bind(this))

		//listen to layout changes that need to be made on the wizard
		this.listenTo(this.model, 'layout', function(view) {
			this.defaultLayoutPosition = this.model.position() - 1
			this._setNewLayout(view)
		}.bind(this))

		this.listenTo(this.model, 'change:index', model => {
			//revert to default layout when going back
			if (!_.isUndefined(this.defaultLayoutPosition) && this.defaultLayoutPosition >= this.model.position()) {
				delete this.defaultLayoutPosition
				this._setNewLayout(DefaultWizardLayout)
			}
		})

		this.listenTo(this.model, 'toggleErrors', opts => this.toggleErrors(opts))
	},

	toggleErrors: function(opts={}) {
		if (opts.message) {
			this.formView.error(opts.message)
		} else {
			// clear errors and enable primary button
			this.formView.clearErrors()
			let primaryButton = this.formView.primaryButton
			primaryButton && primaryButton.enable()
		}
	},

	_setNewLayout: function(view) {
		this.content.remove()
		this.content = new view({model: this.model})
		this.render()
	},

	render: function () {
		this.$el.empty().append(this.content.el)
		this.content.render()

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		this.formView.start()

		return this
	},

	resize: function() {
		this.content.resize && this.content.resize()
	},

	close: function() {
		this.trigger('cancel')
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips, this.content, this.formView],
			'remove')
	}

})

export default ReportWizard

ReportWizard.__filename__ = 'reports/wizard/reports-wizard.js'
